﻿import {
  FETCH_PUBLICACIONES,
  FETCH_PUBLICACION,
  EDIT_PUBLICACION,
  FETCH_TIPOPUBLICACION,
  IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
  FETCH_ESTADOSVARIACIONES,
  FETCH_MARCAS,
  FETCH_CATEGORIAS,
  FETCH_MOTIVOS,
  SET_FILTRO_PUBLICACIONES,
  SE_MODIFICARON_IMAGENES,
  LOADING_PUBLICACIONES,
  RESET_PUBLICACIONES,
  SET_IMAGES_UPLOADER,
  HAY_CAMBIOS_EN_IMAGENES,
  UPDATE_PUBLICACIONES_LIST,
  RESET_MARCA_Y_CATEGORIA,
  RESET_LIST_PUBLICACIONES,
  UPDATE_PUBLICACIONES_ESTADO,
  FETCH_ALICUOTA_IVA,
  //FETCH_COSTO_FEE,
  //RESET_COSTOS,
} from './types';

import {
  fetchPublicacionesApi,
  fetchPublicacionApi,
  fetchTipoPublicacionApi,
  fetchVariacionesApi,
  fetchMarcasApi,
  fetchCategoriasApi,
  fetchCategoriaApi,
  fetchMotivosRevisionApi,
  fetchPublicacionesEncabezadoApi,
  fetchAlicuotaIvaApi,
  //fetchCostoBySkuMarketApi,
} from '../api/axios';

import {
  nuevaPublicacion,
  mapPublicacion,
  getIdEstadoPublicacion,
  resetPublicacion
} from '../helper/publicacionHelper'

export const seModificaronImagenes = (boolean) => dispatch => {
  dispatch({
    type: SE_MODIFICARON_IMAGENES,
    payload: boolean
  });
}

export const setFiltroPublicacion = (filtro) => dispatch => {
  dispatch({
    type: SET_FILTRO_PUBLICACIONES,
    payload: filtro
  });
}

export const fetchPublicaciones = (params) => async dispatch => {
  dispatch({
    type: LOADING_PUBLICACIONES,
    payload: true
  });

  const req = fetchPublicacionesApi(params);
  req.then((publicaciones) => {
    
    if (publicaciones.elementos != undefined) {
      publicaciones.elementos.forEach((p, index) => {
        publicaciones.elementos[index]["imagen"] = p.imagenes.shift();
      });
    }

    dispatch({
      type: FETCH_PUBLICACIONES,
      payload: publicaciones
    });

    dispatch({
      type: LOADING_PUBLICACIONES,
      payload: false
    });

  })
}


export const fetchPublicacionesEncabezado = (params) => async dispatch => {
    dispatch({
        type: LOADING_PUBLICACIONES,
        payload: true
    });

    const req = fetchPublicacionesEncabezadoApi(params);
    req.then((publicaciones) => {

        if (publicaciones.elementos != undefined) {
            publicaciones.elementos.forEach((p, index) => {
                publicaciones.elementos[index]["imagen"] = p.imagenes.shift();
            });
        }

        dispatch({
            type: FETCH_PUBLICACIONES,
            payload: publicaciones
        });

        dispatch({
            type: LOADING_PUBLICACIONES,
            payload: false
        });

    })
}

export const fetchTiposPublicacion = (idSeller) => async dispatch => {
  const req = fetchTipoPublicacionApi(idSeller);
  req.then((tipos) => {

    dispatch({
      type: IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
      payload: true
    });

    dispatch({
      type: FETCH_TIPOPUBLICACION,
      payload: tipos.tiposPublicaciones
    });
  })
}

export const loadedTipoPublicacion = (value) => dispatch => {
  dispatch({
    type: IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
    payload: value
  });
}

export const fetchPublicacion = (id, idSeller) => async dispatch => {

  dispatch({ type: LOADING_PUBLICACIONES, payload: true });

  if (typeof id !== 'undefined' && typeof idSeller !== 'undefined') {
    return fetchPublicacionApi(id)
      .then(publicacion => {
        dispatch({
          type: FETCH_PUBLICACION,
          payload: mapPublicacion(publicacion.elementos.shift())
        });
      })
      .catch(err => {
        // si querés podés setear una publicación vacía o mostrar toast aquí
      })
      .finally(() => {
        dispatch({ type: LOADING_PUBLICACIONES, payload: false });
      });
  } else {
    dispatch({
      type: FETCH_PUBLICACION,
      payload: nuevaPublicacion()
    });
    dispatch({ type: LOADING_PUBLICACIONES, payload: false });
  }
};

export const editPublicacion = (publicacion) => dispatch => {
  return new Promise((resolve) => {
    dispatch({
      type: EDIT_PUBLICACION,
      payload: publicacion
    });
    resolve();
  });
}

export const fetchVariaciones = () => async dispatch => {
  const req = fetchVariacionesApi();
  req.then((variaciones) => {

    dispatch({
      type: FETCH_ESTADOSVARIACIONES,
      payload: variaciones.estados
    });
  })
}

export const fetchMarcas = (descripcion = "") => async dispatch => {
  let options = [];

  const req = fetchMarcasApi(descripcion);
  req.then((marcas) => {
    marcas.elementos.map((marca) => options.unshift({ value: marca.codigo, label: marca.descripcion }));
    dispatch({
      type: FETCH_MARCAS,
      payload: options
    });
  })
}


export const fetchCategorias = (descripcion = "") => async dispatch => {
  let options = [];

  const req = fetchCategoriasApi(descripcion);
  req.then((categorias) => {

    if (categorias.elementos != undefined) {
      categorias.elementos.map((categoria) => options.unshift({ value: categoria.codigo, label: categoria.descripcion }));
    }

    dispatch({
      type: FETCH_CATEGORIAS,
      payload: options
    });
  })
}

export const fetchCategoria = (codigo) => async dispatch => {
  const req = fetchCategoriaApi(codigo);

  req.then((response) => {

    let options = { value: response.subFamilia.descripcion, label: response.subFamilia.descripcion };

    dispatch({
      type: FETCH_CATEGORIAS,
      payload: options
    });
  })
}

export const fetchMotivosRevision = () => async dispatch => {
  const req = fetchMotivosRevisionApi();

  req.then((response) => {
    dispatch({
      type: FETCH_MOTIVOS,
      payload: response.motivos
    })
  })
}

export const resetPublicaciones = () => dispatch => {
dispatch({
  type: RESET_PUBLICACIONES,
  payload: resetPublicacion() 
});
};


export const resetListPublicaciones = () => dispatch => {
  dispatch({
    type: RESET_LIST_PUBLICACIONES,
    payload: []
  });
}

export const updateListPublicaciones = (publicacionesArray, publicacion) => async (dispatch) => {
    // Validación defensiva
    if (!publicacionesArray || !Array.isArray(publicacionesArray.elementos)) {
        console.error("updateListPublicaciones: publicacionesArray.elementos es inválido", publicacionesArray);
        return;
    }

    const elementos = publicacionesArray.elementos.map(item => {
        if (item.idPublicacion === publicacion.idPublicacion) {
            return {
                ...item,
                titulo: publicacion.titulo,
                skuSeller: publicacion.skuSeller,
                skuMarket: publicacion.skuMarket,
                categoria: publicacion.descripcionCategoria,
                precioLista: publicacion.precioLista,
                precioPromocional: publicacion.precioPromocional,
                estado: getIdEstadoPublicacion(publicacion.estado),
                marca: publicacion.descripcionMarca,
                tipoEntrega: publicacion.tipoEntrega[0] === 1 
                    ? "Envio a domicilio o sucursal correo" 
                    : "Retiro en sucursal",
                envioGratis: publicacion.envioGratis,
                tipoPublicacion: publicacion.tipoPublicacion?.descripcion ?? "",
                stock: publicacion.stock
            };
        }
        return item;
    });

    const updatedPublicacionesArray = {
        ...publicacionesArray,
        elementos,
    };

    dispatch({
        type: 'UPDATE_PUBLICACIONES_LIST',
        payload: updatedPublicacionesArray,
    });
};



export const setImagesUploader = (images, values) => dispatch => {
    dispatch({
        type: SET_IMAGES_UPLOADER,
        payload: images
    });

    dispatch({
        type: HAY_CAMBIOS_EN_IMAGENES,
        payload: values
    });
}


export const resetMarcaYCategoria = () => dispatch => {
  dispatch({
      type: RESET_MARCA_Y_CATEGORIA,
      payload: {
          marca: { label: '', value: '' },
          categoria: { label: '', value: '' }
      }
  });
};


export const updateListPublicacionesEstado = (idPublicacion, estado) => (dispatch, getState) => {
  const { publicaciones } = getState().publicaciones;

  const elementosActualizados = publicaciones.elementos.map(item =>
      item.idPublicacion === idPublicacion
          ? { ...item, estado }
          : item
  );

  const publicacionesActualizadas = {
      ...publicaciones,
      elementos: elementosActualizados,
  };

  dispatch({
      type: UPDATE_PUBLICACIONES_ESTADO,
      payload: publicacionesActualizadas,
  });
};

export const fetchTiposAlicuotasIva = () => async dispatch => {
    const req = fetchAlicuotaIvaApi();
    req.then((response) => {

        dispatch({
            type: FETCH_ALICUOTA_IVA,
            payload: response.data.tiposAlicuotaIva,
        });
    })
}

//export const fetchCostoBySkuMarket = (skuMarket, idTipoPublicacion) => async dispatch => {
//    const req = fetchCostoBySkuMarketApi(skuMarket, idTipoPublicacion);
//    req.then(response => {
//        dispatch({
//            type: FETCH_COSTO_FEE,
//            payload: response
//        });
//    });
//}

//export const resetCostos = () => dispatch => {

//    dispatch({
//        type: RESET_COSTOS,
//        payload: {}
//    });
//}
